import { render, staticRenderFns } from "./BlockRequisites.vue?vue&type=template&id=110b509d&scoped=true&"
import script from "./BlockRequisites.vue?vue&type=script&lang=ts&"
export * from "./BlockRequisites.vue?vue&type=script&lang=ts&"
import style0 from "./BlockRequisites.vue?vue&type=style&index=0&id=110b509d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110b509d",
  null
  
)

export default component.exports